/**
 * Cookiebot's  public window events.
 */
const COOKIE_CONSENT_EVENTS = ["CookiebotOnConsentReady", "CookiebotOnAccept"];
/**
 * Cookiebot adapter.
 *
 * Covers three cases: a fresh acceptance, a returning visitor whose stored consent was
 * already resolved before we subscribed, and a decline that is later changed to an accept.
 */
export function makeCookiebotConsentProvider(options = {}) {
    return {
        subscribe(onGranted) {
            // resolved lazily so that nothing touches `window` during a server-side render
            const win = options.win ?? (typeof window !== "undefined" ? window : undefined);
            if (typeof win?.addEventListener !== "function") {
                return () => { };
            }
            let alreadyGranted = false;
            const handler = () => {
                const consent = win.Cookiebot?.consent;
                if (alreadyGranted || !consent?.marketing) {
                    return;
                }
                alreadyGranted = true;
                onGranted(consent);
            };
            COOKIE_CONSENT_EVENTS.forEach((event) => win.addEventListener(event, handler));
            // The visitor may already have answered before this subscription was set up.
            if (win.Cookiebot?.hasResponse || win.Cookiebot?.consent) {
                handler();
            }
            return () => COOKIE_CONSENT_EVENTS.forEach((event) => win.removeEventListener(event, handler));
        },
    };
}
